import React, { useEffect, useRef } from 'react';
import Input from '../../../components/inputs/Input';
import Checkbox from '../../../components/inputs/Checkbox';
import { ProjectPostRequest } from '../../../types/project/ProjectPostRequest';
import { focusNextInput } from '../../../utils/focusNextInput';
import YmPicker from '../../../components/picker/YmPicker';
import { format } from 'date-fns';
import YmdPicker from '../../../components/picker/YmdPicker';
import SubmitAndCancelButton from '../../../components/button/SubmitAndCancelButton';

interface AddProjectRowProps {
  item: ProjectPostRequest;
  onChange: (key: keyof ProjectPostRequest, value: string | boolean) => void;
  onAddSubmitButtonClick: () => void;
  onSubmitCancelButtonClick: () => void;
}

const AddProjectRow: React.FC<AddProjectRowProps> = ({
  item,
  onChange,
  onAddSubmitButtonClick,
  onSubmitCancelButtonClick,
}) => {
  const inputsRef = useRef<(HTMLInputElement | HTMLButtonElement)[]>([]);

  // 最初の input に自動フォーカス
  useEffect(() => {
    if (inputsRef.current[0]) {
      inputsRef.current[0].focus();
    }
  }, []);

  return (
    <>
      <td>
        <Input
          value={item.projectNumber}
          onChange={(e) => onChange('projectNumber', e.target.value)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 0)}
        />
      </td>
      <td>
        <Input
          value={item.projectName}
          onChange={(e) => onChange('projectName', e.target.value)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 1)}
        />
      </td>
      <td>
        <Input
          value={item.clientName}
          onChange={(e) => onChange('clientName', e.target.value)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 2)}
        />
      </td>
      <td>
        <YmdPicker
          selectedDate={item.startDate ? new Date(item.startDate) : null}
          setSelectedDate={(date) =>
            onChange('startDate', date ? format(date, 'yyyy-MM-dd') : '')
          }
          placeholder="年/月/日"
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 3)}
        />
      </td>
      <td>
        <YmdPicker
          selectedDate={item.endDate ? new Date(item.endDate) : null}
          setSelectedDate={(date) =>
            onChange('endDate', date ? format(date, 'yyyy-MM-dd') : '')
          }
          placeholder="年/月/日"
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 4)}
        />
      </td>
      <td>
        <Checkbox
          checked={item.isUnproductive}
          onChange={(checked) => onChange('isUnproductive', checked)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 5)}
        />
      </td>
      <td>
        <Checkbox
          checked={item.isDairen}
          onChange={(checked) => onChange('isDairen', checked)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 6)}
        />
      </td>
      <td></td>
      <td></td>
      <td className="text-center">
        <SubmitAndCancelButton
          onSubmit={() => onAddSubmitButtonClick()}
          onCancel={() => onSubmitCancelButtonClick()}
          submitButtonRef={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          cancelButtonRef={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onSubmitKeyDown={(e) => focusNextInput(e, inputsRef, 7)}
          onCancelKeyDown={(e) => focusNextInput(e, inputsRef, 8)}
        />
      </td>
    </>
  );
};

export default AddProjectRow;
